<template>
    <div :class="['footer', {'is-mobile': isMobile }, { 'min-footer': parseFloat(height) < 715 && !isMobile }]">
        <h3 class="title" v-if="$route.params.lang !== 'EN'">{{text[0]}}</h3>
        <picture v-if="$route.params.lang !== 'EN'">
            <source srcset="../assets/image/n_logo1@3x.png" media="(max-width: 600px)">
            <img src="../assets/image/n_logo1@2x.png" alt="">
        </picture>        
        <hr v-if="$route.params.lang !== 'EN'">
        <h3 class="title">{{text[1]}}</h3>
        <picture>
            <source srcset="../assets/image/n_logo2@3x.png" media="(max-width: 600px)">
            <img src="../assets/image/n_logo2@2x.png" alt="">
        </picture>        
        <div class="invest"></div>
        <div class="copyright">
            <div class="clearfix">
                <span class="f-left" v-html="text[2]"></span>
                <!-- <span class="f-left pc" v-if="!isMobile">Copyright © {{ +new Date().getFullYear() }} Airlook <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048575" target="_blank">京公安网备11010502048575</a><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备16010436号-1</a> </span>
                <div class="f-left mobile" v-if="isMobile"><div>Copyright © {{ +new Date().getFullYear() }} Airlook</div> <div class="span_con"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048575" target="_blank">京公安网备11010502048575</a> <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备16010436号-1</a></div></div> -->
                <div class="f-right">
                    <a @click="handleToAbout(1)">{{text[3]}}</a>
                    <!-- <a @click="handleToAbout(2)">{{text[4]}}</a>
                    <a @click="handleToAbout(2)">{{text[5]}}</a> -->
                    <a @click="handleToAbout(2)">联系我们</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isMobile } from '@/js/utils';
import { mapState } from 'vuex';
import { footer } from '@/js/text'

export default {
    name: 'foot',
    data() {
        return {
            isMobile: false,
            height: 0
        }
    },
    computed: {
        text() {
            return this.$route.params.lang === 'CN' ? footer.CN : footer.EN
        }
    },
    methods: {
        toTop() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            const animate = () => {
                scrollTop = scrollTop * 0.95
                document.documentElement.scrollTop = scrollTop
                document.body.scrollTop = scrollTop
                if(scrollTop < 10) {
                    document.documentElement.scrollTop = 0
                    document.body.scrollTop = 0
                }else {
                    requestAnimationFrame(animate)
                }
            }
            animate()
            this.$emit('toTop')
        },
        handleToAbout(type) {
            if(type === 1) {
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0
                
                this.$router.push({path: `/${this.$route.params.lang}/about${type === 1 ? '': '#contact'}`}, () => {})
            }else {
                // if(this.$route.name === 'about')
                // this.$emit('contact')
                this.$router.push({ path: `/${this.$route.params.lang}/contact`}, () => {})
                return
            }            
        },
        resize() {
            this.isMobile = window.innerWidth <= 600 || isMobile()
        }
    },
    created() {
        this.height = window.innerHeight
    },
    mounted() {
        this.isMobile = window.innerWidth <= 600 || isMobile()
        window.addEventListener('resize', this.resize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize)
    }
}
</script>

<style lang="scss">
    .footer {
        height: auto;
        overflow: hidden;
        background: #303030;
        text-align: center;
        text-align-last: center;
        font-size: 0;
        position: relative;
        box-sizing: border-box;
        &:not(.is-mobile) {
            min-width: 1200px;
        }
        &.fixed {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0
        }
        &.swiper-slide {
            height: 100%;
            .copyright {
                position: absolute;
                bottom: 0
            }
        }
        .title {
            font-size: 30px;
            color: rgba(204,204,204,1)!important;
            &:nth-of-type(1) {
                padding: 86px 0 79px;
            }
            &:nth-of-type(2) {
                padding: 55px 0 60px;
            }
        }
        hr {
            background: #646464;
            border: 0;
            width: 1200px;
            height: 1px;
        }
        img {
            width: 1200px;
            margin-bottom: 46px;
        }
        &.min-footer {
            .copyright {
                height: 80px;
                line-height: 80px;
                margin-top: 50px;
            }
            .to-top {
                margin-top: 20px
            }
            .title {
                &:nth-of-type(1) {
                    padding: 70px 0 50px;
                }
                &:nth-of-type(2) {
                    padding: 45px 0 50px;
                }
            }
        }
        .copyright {
            height: 120px;
            height: 10%;
            background: #181818;
            margin-top: 100px;
            bottom: 0;
            width: 100%;
            font-size: 16px;
            color: #7F7F7F;
            letter-spacing: 0.57px;
            line-height: 120px;
            text-align: left;
            font-size: 14px;
            &>div {
                width: 1200px;
                margin: 0 auto;
            }
            span {
                margin-right: 30px;
                a {
                    color: #7F7F7F;
                    text-decoration: none;
                }
            }
            .copyright_con{
              a{
                padding: 0 10px;
              }
            } 
            .f-right a {
                color: #7F7F7F;
                text-decoration: none; 
                cursor: pointer;            
                padding: 0 24px;
                &:nth-child(-n+2) {
                    border-right: 1px solid #7f7f7f;
                }
                &:nth-last-child(1){
                    padding-right: 0;
                    border-right: none;
                }
            }
            &:not(.is-mobile) {
                .copyright_con {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    &>div {
                        padding: 0 !important;
                        a, p {
                            vertical-align: middle;
                            color: #7F7F7F!important;
                        }
                    }
                    img {
                        height: 18px;
                        width: auto;
                    }
                }
            }
        }
        &.is-mobile {
            padding-top: 3rem;
            h3.title {
                font-size: 0.8rem;
                margin-bottom: 2.2rem;
                text-align: center;
                padding: 0;
            }
            img {
                display: block;
                width: calc(100% - 2rem);
                margin: 0 auto;
            }
            hr {
                width: 90%;
                height: 0.05rem;
                margin: 2.3rem auto 2.2rem;
                background: #646464;
            }
            .copyright {
                height: 6rem;
                width: 100%;
                line-height: 0.8rem;
                padding-top: 1.5rem;
                box-sizing: border-box; 
                margin-top: 3.2rem;  
                .f-left,.f-right {
                    float: none
                }             
                &>div {
                    width: 100%;
                    text-align: center;
                }
                span {
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    bottom: 1rem;
                    left: 0;
                    margin: 0;
                    font-size: 0.5rem;
                    line-height: 1rem;
                }
                .copyright_con{
                  bottom: auto;
                  position: relative;
                  display: flex;
                  justify-content: center;
                  font-size: 0;
                  &>a {
                    line-height: 1.2rem;
                    font-size: 0.5rem;
                  }
                  &>div {
                    display: inline-block;
                    padding: 0!important;
                    font-size: 0.5rem;
                    width: auto!important;
                    margin: 0!important;
                    p, a {
                        display: inline-block!important;
                        line-height: 1.2rem!important;
                        height: inherit!important;
                        vertical-align: middle;
                        color: #7F7F7F!important;
                    }
                    img {
                        height: 0.5rem;
                        width: auto;
                        margin-top: .35rem;
                    }
                    
                  }
                }
                .f-right a {
                    font-size: 0.6rem;
                    &:nth-last-child(1){
                        padding-right: 24px;
                    }
                }
            }
            &.isMin {
                padding-top: 2.5rem;
                .title {
                    margin-bottom: 1rem
                }
                hr {
                    margin: 1.5rem auto;
                }
                .copyright {
                    height: 5rem;
                    padding-top: 1.2rem;
                    a {
                        padding: 0 0.7rem;
                    }
                }
            }
        }
        @media screen and (max-width: 1200px){
            &:not(.is-mobile) {
                img {
                    width: 90%;
                    margin: 0 auto 40px;
                }
                .copyright {
                    margin-top: 60px;
                }
                .copyright > div {
                    width: 100%;
                    font-size: 14px; 
                    span {
                        margin-right: 5px;
                    }
                    a {
                        padding: 0 10px;
                    }
                }
                .to-top img {
                    width: 80px;
                }
            }
        }
    }
    .english .footer {
        .title {
            padding-top: 116px;
        }
        @media screen and (max-width: 1440px){
            .title {
                padding-top: 70px;
            }
        }
        @media screen and (max-width: 600px){
            &.is-mobile {
                padding-top: 2rem;
            }
            .copyright .f-right {
                display: flex;
                align-items: center;
                a {
                    display: block;
                    flex: 1;
                    height: 100%;
                    &:nth-child(1) {
                        border: 0;
                    }
                    &:nth-child(2) {
                        border-left: 1px solid #7f7f7f
                    }
                }
            }
        }
    }
</style>